import { render, staticRenderFns } from "./ProjectEditLocality.vue?vue&type=template&id=08dc32dc&"
import script from "./ProjectEditLocality.vue?vue&type=script&lang=js&"
export * from "./ProjectEditLocality.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports